import React, { useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import { Redirect } from 'react-router-dom';
import { ActionType, StoreContext } from '../../state/store';
import { Button } from '@scholastic/volume-react';
import StatsNav from '../Nav/Nav';

import './Header.scss';

const Header = () => {
  const { state, dispatch } = useContext(StoreContext);
  const customer = state.customerInfo;

  const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(() => {
    checkReload();
  });

  const checkReload = () => {
    if (Object.keys(state).length === 2) {
      logout();
    }
  };

  const logout = () => {
    if (isAuthenticated) {
      dispatch({ type: ActionType.LOGOUT, data: null });
    }
    setIsAuthenticated(false);
  };

  if (
    isAuthenticated === false &&
    (!Cookies.get('adminDetails') || Cookies.get('adminDetails') === null)
  ) {
    return <Redirect to="/" />;
  }

  return (
    <div className="stats-header">
      <div className="stats-header__custom">
        <div className="stats-header__logo">
          <span className="stats-header__red-text">SCHOLASTIC</span>

          <span className="stats-header__black-text">STATISTICAL REPORTING</span>
        </div>

        <div className="stats-header__navigation">
          <StatsNav />
        </div>

        <div className="stats-header__logout-holder">
          <Button color="warning" size="small" id="logout" type="button" onClick={logout}>
            Logout
          </Button>
        </div>
      </div>

      <div className="stats-header__banner">
        <span className="stats-header__title">Welcome, {customer?.result.customername}</span>
      </div>
    </div>
  );
};

export default Header;
